import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useDispatch } from "react-redux";
import { setOffset, updateL1Property } from "../../WorkbookSlice";
import { setSheetControls } from "../../WorkbookControllingSlice";
import {
  getChartDetails,
  getVizStyleArray,
} from "../../../../middleware/getVizDetails";

export default function VizStyle({
  closeModal,
  SheetDetails,
  setVizType,
  currentVizTpe,
}) {
  const SheetIdchart = SheetDetails.Sheetid;
  const dispatch = useDispatch();
  const [selectedChart, setSelectedChart] = useState(null);
  // console.log(currentVizTpe);
  const handleIconClick = (event, chart) => {
    event.stopPropagation(); // Stop click event from bubbling up to parent elements
    setVizType(chart);
    setSelectedChart(chart);
    // console.log(chart);
    // if current vizType is cordinate map and new vizType is not cordinate map playing the paused query
    if (currentVizTpe === "cordinatemap" && chart !== "cordinatemap") {
      // console.log("jio");
      dispatch(
        setSheetControls({
          Sheetid: SheetIdchart,
          controls: {
            isPause: false,
          },
          calledFrom: "vizstyle",
        })
      );
    }
    if (currentVizTpe !== "table" && chart === "table") {
      // console.log("hi");
      dispatch(
        setOffset({
          limit: 25,
          vizType: chart,
          Sheetid: SheetIdchart,
          offset: 0,
        })
      );
    }
    if (currentVizTpe === "table" && chart !== "table") {
      // console.log("hi");
      dispatch(
        setOffset({
          limit: 500,
          vizType: chart,
          Sheetid: SheetIdchart,
          offset: 0,
        })
      );
    }
    dispatch(
      updateL1Property({
        SheetId: SheetIdchart,
        key: "VizType",
        value: chart,
      })
    );
    closeModal();
  };

  return (
    <main className="fixed inset-0 bg-gray-600 bg-opacity-50 flex flex-col items-center justify-center z-50">
      <section className="flex flex-col gap-2 w-96 h-[80%] bg-white rounded shadow-2xl z-20">
        <div className="flex justify-between items-center font-medium p-2 bg-gray-50">
          Select a chart
          <RxCross2 className="cursor-pointer" onClick={closeModal} />
        </div>
        <section className="grid grid-cols-3 gap-4 p-4 overflow-y-auto max-h-[600px]">
          {getVizStyleArray().map((chart, index) => (
            <button
              key={index}
              className="flex flex-col items-center justify-center cursor-pointer space-y-1"
              onClick={(event) => handleIconClick(event, chart.value)}
            >
              <img
                src={chart.iconSrc}
                alt={chart.label}
                className={`w-20 h-20 p-2 border rounded-md object-contain hover:shadow-md ${
                  selectedChart === chart.value
                    ? "border-blue-700"
                    : "border-gray-300"
                }`}
              />
              <span className="text-sm font-light text-center">
                {chart.label}
              </span>
            </button>
          ))}
        </section>
      </section>
    </main>
  );
}
